(function () {
  'use strict';

  var STORAGE_KEY = 'wynch_footer_manifest_variant_v1';

  function readConfig(root) {
    var source = root.querySelector('[data-wynch-footer-manifest-config]');
    if (!source) return null;

    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      return null;
    }
  }

  function readStoredVariant() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function storeVariant(variantId) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, variantId);
    } catch (error) {
      // The selected variant still works when storage is unavailable.
    }
  }

  function selectVariant(variants, experimentEnabled) {
    if (!experimentEnabled || variants.length < 2) return variants[0];

    var storedId = readStoredVariant();
    var storedVariant = variants.find(function (variant) {
      return variant.id === storedId;
    });
    if (storedVariant) return storedVariant;

    var selected = variants[Math.floor(Math.random() * variants.length)];
    storeVariant(selected.id);
    return selected;
  }

  function addAttribution(link, experimentId, variantId) {
    try {
      var destination = new URL(link.href, window.location.origin);
      destination.searchParams.set('utm_source', 'footer');
      destination.searchParams.set('utm_medium', 'internal');
      destination.searchParams.set('utm_campaign', experimentId);
      destination.searchParams.set('utm_content', variantId);
      link.href = destination.toString();
    } catch (error) {
      // Keep the server-rendered destination when URL parsing is unavailable.
    }
  }

  function publish(eventName, payload) {
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        var publishResult = window.Shopify.analytics.publish(eventName, payload);
        if (publishResult && typeof publishResult.catch === 'function') {
          publishResult.catch(function () {
            // Analytics must never prevent navigation or footer interaction.
          });
        }
      }
    } catch (error) {
      // Analytics must never prevent navigation or footer interaction.
    }
  }

  function eventPayload(root, link, experimentId, variantId) {
    return {
      experiment_id: experimentId,
      variant_id: variantId,
      language: document.documentElement.lang || '',
      section_id: root.getAttribute('data-section-id') || '',
      destination_path: link.pathname
    };
  }

  function trackView(root, link, payload) {
    var tracked = false;
    var send = function () {
      if (tracked) return;
      tracked = true;
      publish('wynch:footer_manifest_view', payload);
    };

    if (typeof window.IntersectionObserver !== 'function') {
      send();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      send();
    }, { threshold: 0.5 });

    observer.observe(link);
  }

  function initialize(root) {
    if (root.hasAttribute('data-wynch-footer-manifest-ready')) return;

    var link = root.querySelector('[data-wynch-footer-manifest-link]');
    var headline = root.querySelector('[data-wynch-footer-manifest-headline]');
    var body = root.querySelector('[data-wynch-footer-manifest-body]');
    var mobileHeadline = root.querySelector('[data-wynch-footer-manifest-mobile-headline]');
    var mobileBody = root.querySelector('[data-wynch-footer-manifest-mobile-body]');
    var config = readConfig(root);
    if (!link || !headline || !body || !mobileHeadline || !mobileBody || !config || !Array.isArray(config.variants)) return;

    var variants = config.variants.filter(function (variant) {
      return variant && typeof variant.id === 'string' && typeof variant.headline === 'string' && variant.headline.trim();
    });
    if (!variants.length) return;

    var experimentEnabled = link.getAttribute('data-experiment-enabled') === 'true';
    var selected = selectVariant(variants, experimentEnabled);
    var experimentId = config.experiment || 'footer_manifest_v1';

    headline.textContent = selected.headline;
    body.textContent = selected.body || '';
    mobileHeadline.textContent = selected.mobileHeadline || selected.headline;
    mobileBody.textContent = selected.mobileBody || selected.body || '';
    link.setAttribute('data-variant-id', selected.id);
    addAttribution(link, experimentId, selected.id);

    var payload = eventPayload(root, link, experimentId, selected.id);
    link.addEventListener('click', function () {
      publish('wynch:footer_manifest_click', payload);
    });
    trackView(root, link, payload);

    root.setAttribute('data-wynch-footer-manifest-ready', 'true');
  }

  function initializeAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-wynch-footer-manifest]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
